
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PrinterListHeader extends Vue {
  @Prop(String) public title: string;
}
